import React, { Component } from 'react';
import '../components/styles/carousel.css';
import d1 from '../assets/1.jpg';
import d2 from '../assets/2.jpg';
import d3 from '../assets/3.jpg';
import d4 from '../assets/4.jpg';
import d5 from '../assets/5.jpg';
import d6 from '../assets/6.jpg';
import d7 from '../assets/7.jpg';
import d8 from '../assets/8.jpg';
import d9 from '../assets/9.jpg';
import d10 from '../assets/10.jpg';
import d11 from '../assets/11.jpg';
import d12 from '../assets/12.jpg';
import d14 from '../assets/14.jpg';


class Carousel extends Component {

    render() {
        return (

            <div class="cMain">

                <div class="slider">
                    <div class="slide-track">
                        <div class="slide">
                            <img class="carouselIMG" src={d1} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d2} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d3} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d4} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d5} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d6} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d7} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d8} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d9} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d10} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d11} alt="d5" />
                        </div>
                        <div class="slide">
                            <img class="carouselIMG" src={d12} alt="d5" />
                        </div>                  
                        <div class="slide">
                            <img class="carouselIMG" src={d14} alt="d5" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Carousel;        